import { useEvoModals } from '@/app/components/hotel-detail/evo/EvoModalsProvider';
import { LmnDealInfoModal } from '@/app/components/hotel-detail/LmnDealInfoModal';
import { EvoRoomCancellationTypeSelectionModal } from '@/app/components/hotel-detail/evo/rooms/EvoRoomCancellationTypeSelectionModal';
import { EvoRoomCancellationInformationModal } from '@/app/components/hotel-detail/evo/rooms/EvoRoomCancellationInformationModal';
import { EvoRoomPromotionInformationModal } from '@/app/components/hotel-detail/evo/rooms/EvoRoomPromotionInformationModal';
import { MealPlanIncludedOptionsModal } from '@/app/components/hotel-detail/rooms/MealPlanIncludedOptionsModal';
import { useOffersContext } from '@/app/components/hotel-detail/OffersProvider';

export function EvoModals() {
  const {
    isLmnDealModalOpen,
    openLmnDealModal,
    closeLmnDealModal,
    isCancellationTypeSelectionModalOpen,
    closeCancellationTypeSelectionModal,
    cancellationPoliciesRoom,
    isCancellationPoliciesModalOpen,
    openCancellationPoliciesModal,
    closeCancellationPoliciesModal,
    promotionInfo,
    isPromotionInfoModalOpen,
    openPromotionInfoModal,
    closePromotionInfoModal,
    mealPlanInfoRateId,
    isMealPlanInfoModalOpen,
    openMealPlanInfoModal,
    closeMealPlanInfoModal,
  } = useEvoModals();
  const { offersData } = useOffersContext();

  // Resolved from the current rooms rather than kept as a snapshot: after a rooms refetch the rates
  // are replaced, and a stale config would be what a forward navigation reopened the modal with.
  // When the rate is gone the modal simply does not render, so nothing can advertise a dead plan.
  const mealPlanInfo = mealPlanInfoRateId
    ? offersData?.rooms?.flatMap((room) => room.configurations).find(({ id }) => id === mealPlanInfoRateId)
    : undefined;

  return (
    <>
      <LmnDealInfoModal
        isOpen={isLmnDealModalOpen}
        onClose={closeLmnDealModal}
        onOpenByBrowserHistory={openLmnDealModal}
      />
      <EvoRoomCancellationTypeSelectionModal
        isOpen={isCancellationTypeSelectionModalOpen}
        onClose={closeCancellationTypeSelectionModal}
      />
      {cancellationPoliciesRoom && (
        <EvoRoomCancellationInformationModal
          id={cancellationPoliciesRoom.roomId}
          isOpen={isCancellationPoliciesModalOpen}
          mealPlans={cancellationPoliciesRoom.configurations}
          onDismiss={closeCancellationPoliciesModal}
          onOpenByBrowserHistory={() => openCancellationPoliciesModal(cancellationPoliciesRoom)}
        />
      )}
      {promotionInfo && (
        <EvoRoomPromotionInformationModal
          promotion={promotionInfo}
          isOpen={isPromotionInfoModalOpen}
          onDismiss={closePromotionInfoModal}
          onOpenByBrowserHistory={() => openPromotionInfoModal(promotionInfo)}
        />
      )}
      {mealPlanInfo && (
        <MealPlanIncludedOptionsModal
          id="evo-room"
          mealPlan={mealPlanInfo}
          isOpen={isMealPlanInfoModalOpen}
          onDismiss={closeMealPlanInfoModal}
          onOpenByBrowserHistory={() => openMealPlanInfoModal(mealPlanInfoRateId!)}
        />
      )}
    </>
  );
}
